const currencySymbols = {
    USD: '&#36;',
    CAD: '&#36;',
    BRL: 'R&#36;',
    GBP: '&pound;',
    EUR: '&euro;',
    MXN: '&#x0024;',
    RUB: '&#x20bd',
    AED: 'AED'
};
const currencyPositions = {
    br: -1,
    en: -1,
    it: -1,
    mx: 2,
    ae: -1
};
const decimalPosition = lang => {
    switch (lang) {
        case 'en':
        case 'fi':
        case 'mx':
        case 'us':
        case 'he':
        case 'ar':
        case 'tr':
            return '.';
        default:
            return ',';
    }
};

const decimals = 2;

/**
 * Price Formatter
 * @param {object} context Context object passed from back
 */
module.exports = function PriceFormatter(context = {}) {
    const currencyPosition = currencyPositions[getLanguage()] || 1;
    const decimalCharacter = decimalPosition(getLanguage());

    return {
        /**
         * Prints price formatted for product cards
         * @param {number} value - price of the product
         * @param {string} currency - currency of the product
         * @returns {Object} return HTML with the price and currency ready to be used
         */
        format(value, currency, round) {
            const currencySymbol = currencySymbols[currency] || '';
            let template = '';
            const absValue = Math.abs(value);
            const stringPrice = (Math.round(absValue * 10 ** decimals) / 10 ** decimals).toString();
            const priceParts = stringPrice.split('.');
            let intPart = priceParts[0];
            let decPart = priceParts.length > 1 ? priceParts[1] : '';
            intPart = formatPriceWithThousandsSeparator(intPart);

            if (round && decPart) {
                template = roundDecimals();
            } else if (currencyPosition === -1) {
                template =
                    `<span class="price__currency price__currency--before">${currencySymbol}</span>` +
                    `<span class="price__int">${intPart}</span>`;
            } else if (currencyPosition === 1) {
                template =
                    `<span class="price__int">${intPart}</span>` +
                    `<span class="price__currency price__currency--after">${currencySymbol}</span>`;
            } else {
                template =
                    `<span class="price__currency price__currency--before">${currencySymbol}</span>` +
                    `<span class="price__int">${intPart}</span>` +
                    `<span class="price__currency price__currency--after">${currency}</span>`;
            }
            return template;

            function roundDecimals() {
                decPart = priceParts.length > 1 ? priceParts[1] : '';
                while (decPart.length < decimals) {
                    decPart += '0';
                }
                if (currencyPosition === -1) {
                    return (
                        `<span class="price__currency price__currency--before">${currencySymbol}</span>` +
                        `<span class="price__int">${intPart}</span>${getDecimalTemplate(decPart, decimalCharacter)}`
                    );
                }
                if (currencyPosition === 1) {
                    return (
                        `<span class="price__int">${intPart}</span>${getDecimalTemplate(decPart, decimalCharacter)}` +
                        `<span class="price__currency price__currency--after">${currencySymbol}</span>`
                    );
                }
                return (
                    `<span class="price__currency price__currency--before">${currencySymbol}</span>` +
                    `<span class="price__int">${intPart}</span>${getDecimalTemplate(decPart, decimalCharacter)}` +
                    `<span class="price__currency price__currency--after">${currency}</span>`
                );
            }
        },
        /**
         * Prints price formatted for product cards
         * @param {number} value - price of the product
         * @param {string} currency - currency of the product
         * @returns {Object} return HTML with the price and currency ready to be used
         */
        formatWithForcedDecimals(value, currency) {
            const currencySymbol = currencySymbols[currency] || '';
            let template = '';
            const absValue = Math.abs(value);
            const stringPrice = (Math.round(absValue * 10 ** decimals) / 10 ** decimals).toString();
            const priceParts = stringPrice.split('.');
            let intPart = priceParts[0];
            let decPart = priceParts.length > 1 ? priceParts[1] : '';
            intPart = formatPriceWithThousandsSeparator(intPart);

            template = roundDecimals();

            return template;

            function roundDecimals() {
                decPart = priceParts.length > 1 ? priceParts[1] : '00';
                while (decPart.length < decimals) {
                    decPart += '0';
                }
                if (currencyPosition === -1) {
                    return (
                        `<span class="price__currency price__currency--before">${currencySymbol}</span>` +
                        `<span class="price__int">${intPart}</span>${getDecimalTemplate(decPart, decimalCharacter)}`
                    );
                }
                if (currencyPosition === 1) {
                    return (
                        `<span class="price__int">${intPart}</span>${getDecimalTemplate(decPart, decimalCharacter)}` +
                        `<span class="price__currency price__currency--after">${currencySymbol}</span>`
                    );
                }
                return (
                    `<span class="price__currency price__currency--before">${currencySymbol}</span>` +
                    `<span class="price__int">${intPart}</span>${getDecimalTemplate(decPart, decimalCharacter)}` +
                    `<span class="price__currency price__currency--after">${currency}</span>`
                );
            }
        }
    };

    function formatPriceWithThousandsSeparator(intPart) {
        const numberGroupSeparators = {
            es: '.',
            pt: '.',
            it: '.',
            de: '.',
            fr: ' ',
            br: '.',
            en: ',',
            fi: ',',
            se: ' ',
            mx: ',',
            us: ',',
            ca: '.',
            ve: '.',
            ru: ' ',
            he: ',',
            ar: ',',
            tr: ',',
            ua: ' '
        };

        const numberGroupSeparator = numberGroupSeparators[getLanguage()] || '.';
        const intPartWithSeparation = [];
        let str = '';
        for (let i = intPart.length - 1; i >= 0; i--) {
            str += intPart[i];
            if (str.length === 3) {
                intPartWithSeparation.push(reverseString(str));
                str = '';
            }
        }
        if (str.length > 0) {
            intPartWithSeparation.push(reverseString(str));
        }
        intPartWithSeparation.reverse();
        return intPartWithSeparation.join(numberGroupSeparator);
    }

    function getLanguage() {
        return context.Language || context.language;
    }
};

function getDecimalTemplate(decPart, decimalCharacter) {
    return `<span class="price__sep">${decimalCharacter}</span><span class="price__dec">${decPart}</span>`;
}

function reverseString(str) {
    return str
        .split('')
        .reverse()
        .join('');
}
